import camelCase from 'lodash/camelCase'

import * as HEALTH_DATA_TABLE from '@/models/clinicalProfile/healthDataTable'

const valueFns = [
  // IMC
  {
    valueFn: data => {
      const weight = data.weight
      const height = data.height
      const imc =
        Math.round((Number(weight) / (Number(height) * Number(height))) * 100) /
        100
      return isNaN(imc) ? 0 : imc
    },
    typeIds: [
      '3d65099f-3127-468f-817e-4701b1a67000',
      'b7c0791c-f552-4cf9-9f27-0c4363006700'
    ]
  },
  // Abdômen / Altura
  {
    valueFn: data => {
      const abdominalCircumference = data.abdominalCircumference
      const height = data.height
      const ratio = (
        (Number(abdominalCircumference) * 0.01) /
        Number(height)
      ).toFixed(2)
      return isNaN(ratio) ? 0 : ratio
    },
    typeIds: [
      'b2561b5e-0e51-4968-9237-03eee6087600',
      'c20fafc5-5a99-41b0-8e88-3c7d275f9700'
    ]
  }
]

const emptyValueFn = () => HEALTH_DATA_TABLE.EMPTY_PLACEHOLDER

const getHeaderValueFn = typeId => {
  return (
    valueFns.find(it => it.typeIds.includes(typeId))?.valueFn || emptyValueFn
  )
}

const mapHeadersInCategory = headers => {
  headers.forEach(header => {
    header.key = camelCase(header.key)
    if (header.readOnly) {
      header.valueFn = getHeaderValueFn(header.typeId)
      header.mask = ''
    } else {
      header.mask = HEALTH_DATA_TABLE.maskMap[header.mask] || '###'
    }
  })
}

export const mapServerResToTableData = fromServer => {
  const categories = fromServer.categories
  const tableData = {}
  categories.forEach(category => {
    const headers = category.headers
    if (!headers.length) return
    Object.assign(tableData, { [category.key]: category })
    mapHeadersInCategory(headers)
  })
  return tableData
}
